import Button from 'components/forms/Button'
import imageResize, { generateSrcSet } from 'project/image-proxy-web'
import useWindowSize from 'components/util/useWindowSize'
import useShoppingBag from 'common/useShoppingBag'
import { useRouter } from 'next/router'

const benefits = [
  {
    description:
      'A business address is an important part of your brand. A Prime London business address can help create a winning impression with clients, customers, investors and business associates.',
    title: 'Improve your business image.',
  },
  {
    description: `We do not believe in charging set-up fees. All plans have no hidden fees and no extra costs.`,
    title: 'No set-up fees.',
  },
  {
    description: `We offer rolling monthly contracts. This means that you are never tied into a long contract and can cancel at any time.`,
    title: 'Cancel anytime.',
  },
]

const WorkFromAnywhere = ({ planSummary }) => {
  const size = useWindowSize()
  const { addPlan } = useShoppingBag()
  const router = useRouter()
  const onBuyClick = () => {
    addPlan(planSummary.slug, 'year', planSummary)
    router.push('/checkout')
  }
  return (
    <div>
      <h2 className='fw-semibold text-center mb-6 mb-lg-16 fs-fluid-36-80'>
        Work from anywhere
      </h2>
      <div className='d-flex flex-column-reverse flex-lg-row gap-lg-8'>
        {size.isLgOrHigher && (
          <div
            className='d-flex justify-content-center flex-column position-relative'
            style={{
              width: '46%',
            }}
          >
            <img
              {...generateSrcSet(
                '/images/new/cool-robot-with-tie.png',
                551,
                737,
              )}
              loading='lazy'
              alt='cool robot holding the tie'
              className='position-absolute h-100 object-fit-contain'
              style={{
                maxWidth: '100%',
              }}
            />
          </div>
        )}
        <div className='d-flex flex-1 flex-column gap-3 gap-lg-5'>
          <div className='fw-semibold lh-119 fs-fluid-24-32'>
            Whether you're an entrepreneur, freelancer or startup, our London
            virtual office packages give you the flexibility to operate your
            business on your terms.
          </div>
          {!size.isLgOrHigher && (
            <div className='d-flex align-self-center'>
              <img
                style={{
                  maxWidth: '100%',
                }}
                {...generateSrcSet(
                  '/images/new/cool-robot-with-tie.png',
                  551,
                  737,
                )}
                className='img-fluid'
                height={737}
                width={551}
              />
            </div>
          )}

          {benefits.map((benefit) => (
            <div className='lh-114' key={benefit.title}>
              <div className='fs-lg-24 fw-bold mb-1 mb-lg-1'>
                {benefit.title}
              </div>
              <span
                className='fs-lg-20 fw-semibold color-grey5 mb-0'
                dangerouslySetInnerHTML={{ __html: benefit.description }}
              />
            </div>
          ))}
          <Button
            onClick={onBuyClick}
            className='w-100 w-lg-auto align-self-lg-start'
          >
            Buy Now
          </Button>
        </div>
      </div>
    </div>
  )
}

export default WorkFromAnywhere
